import React, { FC, useEffect, useRef, useState, useMemo } from "react";
import { Button, Table, Upload, Tooltip, message, notification } from "antd";
import { YhBox } from "@/components/YhBox";
import { globalPrompt } from "@/components/message";
import { ColumnsType } from "antd/es/table";
import { usePurchaseOfferDetailsModel } from "./purchaseOfferDetailsModel";
import { RouterParamType } from "@/model/navModel";
import { EditableCell, EditableRow } from "@/components/YHEditTable/editTable";
import { IDetailList } from "../../purchaseOfferType"
import useGlobalModel from "@/model/globalModel";
import { formatNum, bigNumber } from "@/utils/utils";
import { DetailType } from "@/types/ScmEnums";
import { importPropsConfig } from "@/utils/importFile";
import YhTootip from "@/components/YhTootip";
import { roleColumnModel } from "@/utils/roleColumn";
import { purchaseOfferService } from "../../purchaseOfferService";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { PictureOutlined } from "@ant-design/icons";
import { LookPictureModal } from "@/views/lookPicture";
export const TableBox: FC<RouterParamType> = ({ id, mode }) => {
    const {
        detailAddList,
        detailDataSource,
        detailLookList,
        detaiAddDataRowKeys,
        detailDataRowKeys,
        detailEditForm,
        detailLookForm,
        detailAddForm,
        setDetaiAddDataRow,
        setDetailAddList,
        setDetaiAddDataRowKeys,
        setDetailDataRowKeys,
        setDetailDataRow,
        setAddModalVisible,
        setDetailDataSource,
        detailDetailList,
        downloadTpl,
        modelScreenMethod,
        setHistoryVisible,
        setHistoryRow,
        setTopButsControl,
        more, setMore,
        exportPurchaseOfferDetail,
    } = usePurchaseOfferDetailsModel();
    const { user: { roles }, setLoadingInfo } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();
    const typeList = {
        "add": detailAddList,
        "edit": detailDataSource,
        "look": detailLookList,
    }
    const [imageModalVisible, setImageModalVisible] = useState(false);
    const [currentMaterialCode, setCurrentMaterialCode] = useState("");
    // 打开图片模态框
    const handleOpenImageModal = (materialCode: string) => {
        setCurrentMaterialCode(materialCode);
        setImageModalVisible(true);
    };

    // 关闭图片模态框
    const handleCloseImageModal = () => {
        setImageModalVisible(false);
        setCurrentMaterialCode("");
    };
    const typeForm = {
        add: detailAddForm,
        edit: detailEditForm,
        look: detailLookForm
    }
    const onHistoryModel = (record: IDetailList) => {
        setHistoryVisible(true);
        setHistoryRow(record);
    }
    const importCallback = async (list: any) => {
        setLoadingInfo({ loadingVisible: false })
        if (list && list.length) {
            const updateData = (originalData: IDetailList[]) => {
                return originalData.map(originItem => {
                    const found = list.find((newItem: IDetailList) => newItem.id === originItem.id);
                    return found ? {
                        ...originItem,
                        model: found.model,
                        producingArea: found.producingArea,
                        offerPrice: found.offerPrice,
                        deliveryTime: found.deliveryTime,
                        totalPrice: +bigNumber.toFixed(bigNumber.times((found.offerPrice ?? 0), (originItem.num ?? 0)), 2)
                    } : originItem;
                });
            };

            if (mode === "add") {
                setDetailAddList(prev => updateData(prev));
            } else if (mode === "edit") {
                setDetailDataSource(prev => updateData(prev));
            }
        }
    }

    // 删除(做限制)
    const onRemove = (mode: string) => {
        detailDetailList(mode)
    }
    const action = <>
        {mode !== "look" &&
            <>
                <YhAuth resCode={ResourceAuthEnum.P_OFFER_EXPORTPURCHASEOFFERDETAIL}>
                    <Button
                        className="mr-5"
                        type="primary"
                        shape="round"
                        onClick={() => exportPurchaseOfferDetail(typeForm[mode].code)}
                    >导出</Button>
                </YhAuth>
                <YhAuth resCode={ResourceAuthEnum.P_OFFER_UPLOADDETAIL}>
                    <Upload showUploadList={false} className="mr-10 ml-10" {...importPropsConfig(`/zzw-vrm/purchaseOfferDetails/importDetails`, importCallback)}>
                        <Button className="mr-5" type="primary" shape="round">导入</Button>
                    </Upload>
                </YhAuth>
            </>
        }
    </>;

    const defaultColumns = [
        {
            title: '序号',
            fixed: "left",
            width: 80,
            render: (t: any, r: any, i: number) => i + 1
        }, {
            title: '商品编码',
            width: 150,
            dataIndex: 'materialCode',
            render: (text: any, record: any) => (
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    {text}
                    <PictureOutlined
                        style={{ color: '#009688', cursor: 'pointer', marginLeft: 4, fontSize: '22px' }}
                        onClick={() => handleOpenImageModal(record.materialCode)} // 点击打开图片模态框
                    />
                </div>
            ),
        }, {
            title: '商品名称',
            width: 150,
            dataIndex: 'materialName',
            render: (text: any, record: any) => <YhTootip text={text} style={{ maxWidth: "150px" }} />,
        }, {
            title: '规格型号',
            width: 150,
            dataIndex: 'model',
            editable: mode == 'add' || (mode == 'edit' && typeForm[mode].status == "purchase_enquiry.underway"),
        }, {
            title: '适用车型',
            width: 120,
            dataIndex: 'vehicleModel',
            render: (text: any) => <YhTootip text={text} style={{ width: 120 }} />,

        }, {
            title: '品牌',
            width: 100,
            dataIndex: 'brandName',
        }, {
            title: '上装品牌',
            width: 110,
            dataIndex: 'upperClothBrand',
        }, {
            title: '底盘品牌',
            width: 110,
            dataIndex: 'chassisBrand',
        }, {
            title: '单位',
            width: 100,
            dataIndex: 'unitName',
        }, {
            title: '产地',
            width: 120,
            dataIndex: 'producingArea',
            editable: mode == 'add' || (mode == 'edit' && typeForm[mode].status == "purchase_enquiry.underway"),
        }, {
            title: '数量',
            width: 110,
            dataIndex: 'num',
        },
        // {
        //     title: '控制价',
        //     width: 110,
        //     dataIndex: 'controlPrice',
        // }, 
        {
            title: '含税单价',
            width: 110,
            editable: mode == 'add' || (mode == 'edit' && typeForm[mode].status == "purchase_enquiry.underway"),
            dataIndex: 'offerPrice',
        }, {
            title: '交货期',
            width: 120,
            suffix: 'h',
            dataIndex: 'deliveryTime',
            editable: mode == 'add' || (mode == 'edit' && typeForm[mode].status == "purchase_enquiry.underway"),
        }, {
            title: '报价金额',
            width: 120,
            dataIndex: 'totalPrice',
        }, {
            title: '备注',
            width: 130,
            dataIndex: 'note',
            render: (text: any, record: any) => <YhTootip text={text} style={{ maxWidth: "130px" }} />,
        }
    ];

    const removeMaterial = (record: IDetailList) => {
        detailDetailList(mode, record)
    }
    const newSelectColumns = () =>
        defaultColumns.map((col: any, index) => {
            return {
                ...col,
                onCell: (record: IDetailList, rowIndex: number) => ({
                    colIndex: index + 1,
                    rowIndex,
                    record,
                    rules: col?.rules,
                    options: col?.options,
                    editType: col?.editType,
                    editable: col?.editable,
                    onSelectChange: col?.onSelectChange,
                    onSelectFocus: col?.onSelectFocus,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: handleSave,
                    suffix: col.suffix
                }),
            }
        })

    const roleColumns = useMemo(() => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "purchaseOffer", "roleCodes": roles };
        return getRoleColumns("purchaseOffer", "明细", newSelectColumns(), params);
    }, [roles, typeList[mode], defaultColumns]);
    const handleSave = async (row: IDetailList) => {
        let { controlPrice, num, offerPrice, deliveryTime } = row
        row.num = +formatNum(num)
        row.controlPrice = +formatNum(controlPrice)
        row.offerPrice = +formatNum(offerPrice)
        row.controlPrice = +formatNum(controlPrice)
        row.deliveryTime = +formatNum(deliveryTime)
        row.totalPrice = +bigNumber.toFixed(bigNumber.times((row.offerPrice ?? 0), (row.num ?? 0)), 2)
        let newData: any = mode === 'edit' ? detailDataSource : detailAddList
        const index = newData.findIndex((item: any) => row.id === item.id);
        const item = newData[index];
        // purchaseOfferService.updateList({ ...item, ...row })
        newData.splice(index, 1, { ...item, ...row });
        mode === "edit" ? setDetailDataSource([...newData]) : setDetailAddList([...newData])
        setTopButsControl(true)
    }

    const setTypeDetailDataRowKeysAndRow = async (selectedRowKeys: React.Key[], mode: string) => {
        if (mode === DetailType.add) {
            setDetaiAddDataRowKeys(selectedRowKeys)
        } else if (mode === DetailType.edit) {
            setDetailDataRowKeys(selectedRowKeys)
        }
    }
    const setTypeDetailDataRow = async (selectedRows: IDetailList[], mode: string) => {
        if (mode === DetailType.add) {
            setDetaiAddDataRow(selectedRows)
        } else if (mode === DetailType.edit) {
            setDetailDataRow(selectedRows)
        }
    }
    return (
        <YhBox title="询价清单" rightChildren={action} style={{ marginBottom: "10px", height: 'calc(100vh - 305px)' }}>
            <Table
                bordered
                rowKey={record => record.id as string}
                rowSelection={
                    mode === DetailType.look ? undefined : {
                        selectedRowKeys: mode === DetailType.add ? detaiAddDataRowKeys : detailDataRowKeys, //记录选中
                        onChange: (selectedRowKeys: React.Key[], selectedRows: IDetailList[]) => {
                            setTypeDetailDataRowKeysAndRow(selectedRowKeys, mode)
                            setTypeDetailDataRow(selectedRows, mode)
                        },
                        onSelectAll: (selected, selectedRows, changeRows) => {
                            setTypeDetailDataRow(selectedRows, mode)
                        }
                    }}
                columns={roleColumns}
                dataSource={typeList[mode]}
                pagination={false}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    }
                }}
                scroll={{ x: 'max-content', y: more ? 'calc(100vh - 403px)' : 'calc(100vh - 453px)' }}
            />
            <LookPictureModal
                visible={imageModalVisible}
                materialCode={currentMaterialCode}
                onClose={handleCloseImageModal}
            />
        </YhBox>
    )
}